import { createAction } from '@reduxjs/toolkit';

const loadMyTemplates = createAction('LOAD_MY_TEMPLATES');

const deleteTemplate = createAction('DELETE_TEMPLATE');

const duplicateTemplate = createAction('DUPLICATE_TEMPLATE');

export { loadMyTemplates, deleteTemplate, duplicateTemplate };
